import { APIClient } from '@/infrastructure/network/Zipcloud/APIClient'

export class ZipcloudGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
